"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionHrefLangMap = exports.RegionFallbackLanguageMap = exports.SupportedLanguageMetas = exports.SupportedLanguages = exports.LanguageDisplayNameMap = exports.Language = void 0;
const region_1 = require("./region");
var Language;
(function (Language) {
    Language["en"] = "en";
    Language["id"] = "id";
    Language["ja"] = "ja";
    Language["ms"] = "ms";
    Language["th"] = "th";
    Language["vi"] = "vi";
    Language["fil"] = "fil";
    Language["fr"] = "fr";
})(Language = exports.Language || (exports.Language = {}));
exports.LanguageDisplayNameMap = {
    en: 'English',
    id: 'Bahasa Indonesia',
    ja: '日本語',
    ms: 'Bahasa Melayu',
    th: 'ภาษาไทย',
    vi: 'Tiếng Việt',
    fil: 'Pilipino',
    fr: 'Français',
};
exports.SupportedLanguages = [
    Language.en,
    Language.id,
    Language.ja,
    Language.ms,
    Language.th,
    Language.vi,
];
exports.SupportedLanguageMetas = exports.SupportedLanguages.map((language) => ({
    language,
    displayName: exports.LanguageDisplayNameMap[language],
})).sort((l, r) => (l.displayName > r.displayName ? 1 : -1));
exports.RegionFallbackLanguageMap = {
    [region_1.Region.jp]: Language.ja,
    [region_1.Region.th]: Language.th,
    [region_1.Region.my]: Language.ms,
    [region_1.Region.id]: Language.id,
    [region_1.Region.vn]: Language.vi,
    [region_1.Region.us]: Language.en,
    [region_1.Region.gb]: Language.en,
    [region_1.Region.sg]: Language.en,
    [region_1.Region.ph]: Language.en,
    [region_1.Region.ca]: Language.en,
    [region_1.Region.au]: Language.en,
    [region_1.Region.nz]: Language.en,
};
exports.RegionHrefLangMap = {
    [region_1.Region.jp]: 'ja-jp',
    [region_1.Region.th]: 'th-th',
    [region_1.Region.my]: 'ms-my',
    [region_1.Region.id]: 'id-id',
    [region_1.Region.vn]: 'vi-vn',
    [region_1.Region.us]: 'en-us',
    [region_1.Region.gb]: 'en-gb',
    [region_1.Region.sg]: 'en-sg',
    [region_1.Region.ph]: 'en-ph',
    [region_1.Region.ca]: 'en-ca',
    [region_1.Region.au]: 'en-au',
    [region_1.Region.nz]: 'en-nz',
};
